import React from "react";
import Logo from '../assets/images/logo.svg';
import { Link } from "react-router-dom";


const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg myNavigation">
      <div className="container">
        <a className="navbar-brand fw-bold" href="/">
          <img src={Logo} alt="logo" height="30" />
        </a>

        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse navList" id="navMenu">
          <ul className="navbar-nav ms-auto gap-3">
            <li className="nav-item"><Link to="/">Pran AI</Link></li>
            <li className="nav-item"><Link to="/partnerships">Partnerships</Link></li>
            <li className="nav-item"><Link to="/products">Products</Link></li>
            <li className="nav-item"><Link to="/contact">Contact</Link></li>
            <Link to="/getdemo"><button className="getDemo btn btn-primary">Get Demo</button></Link>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
